import { createContext } from 'react';

const PromptContext = createContext({
  isDirty: false,
  // eslint-disable-next-line no-console
  makeDirty: (_dirty: boolean) => console.log('makeDirty handler should be defined')
});

export default PromptContext;
